import { RouteTabs } from '@/components/ui/route-tabs';
import type { PlanningTab } from '@/features/planning';
import { PLANNING_TABS } from '@/features/planning';
import { useLanguage } from '@/i18n/language-hooks';
import { useRoutePrefetch } from '@/lib/queryPrefetch';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

interface PlanningTabsProps {
  activeTab: PlanningTab;
  planId?: string;
}

export function PlanningTabs({ activeTab, planId }: PlanningTabsProps) {
  const { t } = useLanguage();
  const location = useLocation();
  const prefetch = useRoutePrefetch();

  const items = useMemo(
    () =>
      PLANNING_TABS.map((tab) => ({
        id: tab,
        to:
          tab === 'goals' ? '/planning/goals' : planId ? `/planning/${planId}/${tab}` : '/planning',
        label: t(`planning.tabs.${tab}`),
      })),
    [planId, t]
  );

  return (
    <RouteTabs
      ariaLabel={t('planning.tabs.label')}
      activeId={activeTab}
      items={items}
      onPrefetch={prefetch}
      scrollCollapse={{ chromeKey: `${location.pathname}:planning-tabs` }}
    />
  );
}
